// modules
import { createAction } from 'redux-actions'

export const setCompaniesFullList = createAction('SET_COMPANIES_FULL_LIST')
